export var PriceLevel;
(function (PriceLevel) {
    PriceLevel[PriceLevel["ONE"] = 1] = "ONE";
    PriceLevel[PriceLevel["TWO"] = 2] = "TWO";
    PriceLevel[PriceLevel["THREE"] = 3] = "THREE";
    PriceLevel[PriceLevel["FOUR"] = 4] = "FOUR";
    PriceLevel[PriceLevel["FIVE"] = 5] = "FIVE";
    PriceLevel[PriceLevel["SIX"] = 6] = "SIX";
    PriceLevel[PriceLevel["SEVEN"] = 7] = "SEVEN";
})(PriceLevel || (PriceLevel = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHJpY2VFbnVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vY29tcG9uZW50cy9wcmljZS9QcmljZUVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFOLElBQVksVUFRWDtBQVJELFdBQVksVUFBVTtJQUNwQix5Q0FBTyxDQUFBO0lBQ1AseUNBQU8sQ0FBQTtJQUNQLDZDQUFTLENBQUE7SUFDVCwyQ0FBUSxDQUFBO0lBQ1IsMkNBQVEsQ0FBQTtJQUNSLHlDQUFPLENBQUE7SUFDUCw2Q0FBUyxDQUFBO0FBQ1gsQ0FBQyxFQVJXLFVBQVUsS0FBVixVQUFVLFFBUXJCIn0=